module.exports = __webpack_public_path__ + "static/SeeVita-07-23615fbd5d2e9eaf3befefc3c0788d3a.png";